import { Pipe, PipeTransform } from '@angular/core';

import { RdsChip } from '../chips/index';
import { RdsTextFilter } from './text-filter.model';

/**
 * Turn `RdsTextFilter` into RdsChips
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Pipe({
  name: 'rdsTextFiltersToChips'
})
export class RdsTextFiltersToChipsPipe implements PipeTransform {
  transform(value: Array<RdsTextFilter>): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return value.map(f => new RdsChip(`${f.parameter.type}${!!f.text ? ` "${f.text}"` : ''}`, f.parameter.type + f.text));
  }
}
